<script>
  import { mileageStore } from '../../stores';
  import { config } from '../../../scripts/defaultURL';
  import { clearForm, formatPayloadDate } from '../../../scripts/functions';
  import { postData } from '../../../scripts/rest';
  export let mileageData;

  let payload = {
    date: formatPayloadDate(new Date())
  };

  function closeModal() {
    clearForm('input');
    payload = {
      date: formatPayloadDate(new Date())
    };
    document.getElementById('mileageModal').classList.remove('is-active')
    $mileageStore = 'getData'
  }

  function save() {
    postData(`${config.defaultURL}/mileage/add`, payload)
    .catch((error) => console.error('Failed to post mileage:', error))
    .then((res) => {
      console.log(res)
      closeModal()
    })
  }
</script>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>

<div class="modal" id="mileageModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add Mileage</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <div class="field">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label">Date</label>
        <input bind:value={payload.date} class="input" type="date" name="date" placeholder="Select Date" />
      </div>
      <div class="field">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <!-- <label class="label">Destination</label>
        <input bind:value={payload.destination} type="text" class="input" name="destination" placeholder="Travel Destination" /> -->
        <label class="label">Destination</label>
        <input id="destination" list="destinations" bind:value={payload.destination} class="input" name="destination" placeholder="Travel Destination" />
          <datalist id="destinations">
              {#each mileageData as destination}
              <option>{destination}</option>
              {/each}
          </datalist>
      </div>
      <div class="field">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="label">Miles Traveled</label>
        <input bind:value={payload.mileage} type="text" class="input" name="mileage" placeholder="# Miles" />
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button on:click={save} class="button is-primary">Submit</button>
        </div>
        <div class="control">
          <button
            on:click={closeModal}
            class="button is-primary is-light">Cancel</button>
        </div>
      </div>
    </section>
  </div>
</div>
